import apiFetch from '../apiFetch'

export default function (token, values) {
  return apiFetch({endPoint: `Planning/getTotalesPlanning`, method: 'POST', body: values, token: token})
}